/**
 * The unified Canvas-submissions feed model.
 *
 * One row is either a standalone upload (a `CanvasSyncUploads` row) or a
 * SIS bundle that POSTed to Canvas. The two posting paths have different
 * lifecycles, but operators need ONE chronological answer to "what did we
 * send to Canvas?" — splitting it across two pages is exactly how a bundle
 * submission goes unseen (and gets manually re-sent).
 */

import type { SisBundleSummary, UploadSummary } from "@canvas-sync/shared";

export type SubmissionItem =
  | { kind: "upload"; upload: UploadSummary }
  | { kind: "bundle"; bundle: SisBundleSummary };

/** Date used for bucketing + sorting, per kind. */
export function submissionDate(item: SubmissionItem): string {
  return item.kind === "upload"
    ? (item.upload.submittedAt ?? item.upload.queuedAt)
    : (item.bundle.submittedAt ?? item.bundle.createdAt);
}
